<template>
    <section class="products-slider">
        <DefH2 class="products-slider__title">
            <DefLink :href="result?.messages?.title?.link || ''">
                {{ result?.messages?.title?.text || '' }}
            </DefLink>
        </DefH2>
<!--        :nav="screenWidth >= 992"-->
        <DefSlider
            :nav="true"
            :pagination="true"
            :settings="settings"
            ref="slider"
            v-if="result?.items"
        >
            <div
                v-for="item in result.items"
                :key="item.offer && item.offer.id || item.id"
                class="swiper-slide"
            >
                <SliderCard :result="item" />
            </div>
        </DefSlider>
    </section>
</template>

<script>
import DefH2 from "../Def/DefH/DefH2.vue";
import DefLink from "../Def/DefLink/DefLink.vue";
import DefSlider from "../Def/DefSlider/DefSlider.vue";
import SliderCard from "../card/SliderCard/SliderCard.vue";

export default {
    name: 'ProductsSlider',
    components: {SliderCard, DefSlider, DefLink, DefH2},
    selector: '.products-slider',
    props: ['result'],
    data() {
        return {
            settings: {
                slidesPerView: 2,
                spaceBetween: 10,
                autoplay: {
                    delay: 5000,
                },
                breakpoints: {
                    768: {
                        slidesPerView: 4,
                        spaceBetween: 12
                    },
                }
            },
        }
    },
}
</script>

<style lang="scss" scoped>
.products-slider{
    margin-bottom: 64px;

    @include point-lg{
        margin-bottom: 80px;
    }

    :deep(.def-slider__container){
        width: 95%;
        margin-left: auto;
        margin-right: auto;
    }
    :deep(.def-slider__prev){
        left: 0px;
        //transform: translate(-50%, -50%);
    }
    :deep(.def-slider__next){
        right: 0px;
        //transform: translate(50%, -50%);
    }
    :deep(.slider-card){
        border: 1px solid #f5efef;
    }
    :deep(.def-h2){
        font-size: rem(30);
        margin-left: 3%;
    }
    :deep(.def-link){
        text-decoration-line: blink;
    }

}
.products-slider.sale{
    margin-top: 50px;
    @include point-lg{
        margin-top: 0;
    }
}
</style>